<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isVisible"
      max-width="500"
    >
      <v-card>
        <v-card-title
          class="headline text-md-center"
          primary-title
        >
          Resolve Failed Job
        </v-card-title>

        <v-card-text light>
          <p>Are you sure you want to set the Failed Job as resolved?</p>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="isVisible = false"
          >
            <v-icon>
              cancel
            </v-icon>
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="() => { isVisible = false; $emit('submit'); }"
          >
            <v-icon>
              done
            </v-icon>
            Resolve
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ResolveDialog',
  components: {
  },
  props: {
    visible: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
};
</script>
<style lang="scss" />



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/dialogs/failedJob/ResolveDialog.vue